// extracted by mini-css-extract-plugin
export default {"spinWrap":"EditUserPage_spinWrap__T1z5G"};